/*
- MAYOREO30 (30 prendas minimo) MAYOREO30
- MAYOREO50 (50 prendas minimo) MAYOREO50
- MAYOREO100 (100 prendas minimo) MAYOREO100
- MAYOREO200 (200 prendas minimo) MAYOREO200
*/
export const ftMostrarPrecioNormalMayoreo = ({ cuponAplicado, producto }) => {
    if (!cuponAplicado) return producto.precio;

    if (cuponAplicado === "MAYOREO30") {
        return Number(producto.discountOne) === 0
            ? producto.precio
            : producto.discountOne;
    } else if (cuponAplicado === "MAYOREO50") {
        return Number(producto.discountTwo) === 0
            ? producto.precio
            : producto.discountTwo;
    } else if (cuponAplicado === "MAYOREO100") {
        return Number(producto.discountThree) === 0
            ? producto.precio
            : producto.discountThree;
    } else if (cuponAplicado === "MAYOREO200") {
        return Number(producto.discountFour) === 0
            ? producto.precio
            : producto.discountFour;
    }

    return producto.precio;
};
